import React, { useMemo } from 'react';
import {
  DropdownSelector,
  SelectorType,
} from '@vimily/bonjoro-ui-components-v2/DropdownSelector';
import { useTags } from '~/App/Api/Tag/hooks';
import { usePublishSelectModalContext } from '~/App/Modules/Testimonials/Pages/Publish/Editor/Contexts/PublishSelectModalContext';
import cx from 'classnames';

export interface TagsDropdownProps {
  disabled?: boolean;
}

export default function TagsDropdown({ disabled = false }: TagsDropdownProps) {
  const { data: tags = [] } = useTags();

  const publishSelectModalContext = usePublishSelectModalContext()!;

  const { filteredTags, setSelectedTags } = publishSelectModalContext;

  const items = useMemo(
    () =>
      tags.reduce<Record<string, string>>((items, tag) => {
        return {
          ...items,
          [tag.id]: tag.name,
        };
      }, {}),
    [tags]
  );

  const onTagSelect = (selectedTag: string[]) => {
    setSelectedTags(tags.filter((tag) => selectedTag.includes(`${tag.id}`)));
  };

  return (
    <DropdownSelector
      items={items}
      bodyPlaceholder='Choose tags'
      type={SelectorType.Multiselect}
      bodyWidth={245}
      dropdownProps={{ width: 245 }}
      className='border v2-border-neutral-300 border-solid hover:border-transparent h-[40px] v2-text-black z-10'
      bodyContentClassName={cx({ '!cursor-not-allowed': disabled })}
      selected={Object.keys(filteredTags)}
      onSelect={onTagSelect}
      disabled={disabled}
    />
  );
}
